<template>
    <div class="page-wrapper">

        <div class="style1" :class="['header-wrap', { sticky: isSticky }, { stickyoverride: isSticky }]">

            <div class="header-bottom">
                <div class="container">
                    <nav class="navbar navbar-expand-md navbar-light">
                        <router-link class="navbar-brand" to="/">
                            <img
                                class="logo-light"
                                width="150"
                                src="../../assets/images/NewLogo.png"
                                alt="logo" />
                            <img
                                class="logo-dark"
                                src="../../assets/images/NewLogo.png"
                                alt="logo" />
                        </router-link>

                        <div class="collapse navbar-collapse" :class="{ show: active }">
                            <ul class="navbar-nav ms-auto">
                                 <!-- <li class="nav-item">
                                    <router-link to="/" class="nav-link">Home</router-link>
                                </li> -->
                            </ul>

                            <div class="others-options d-flex align-items-center">
                                <div class="header-btn">
                                    <router-link 
                                        :to="{ name: 'HomeOnePage', params: { ToCalculator: false } }" 
                                        style="padding: 8px !important; margin: 15px !important;"
                                        class="btn m-1 style1">
                                        Apply Now
                                    </router-link>
                                </div>
                            </div>
                        </div>

                        <div class="mobile-bar-wrap">
                            
                            <div
                                class="navbar-toggler mobile-menu xl-none"
                                @click="active = !active"
                                :aria-pressed="active ? 'true' : 'false'"
                                v-bind:class="{ active: button_active_state }"
                                v-on:click="button_active_state = !button_active_state">
                                <a href="javascript:void(0);">
                                    <i class="ri-menu-line"></i>
                                    <i class="ri-close-line"></i>
                                </a>
                            </div>
                        </div>
                    </nav>
                </div>
            
            </div>
        </div>

        <div class="content-wrapper" style="margin-top: 55px !important;">
            <div class="breadcrumb-wrap bg-spring">
                <img src="../../assets/images/breadcrumb/br-shape-1.png" alt="Image" class="br-shape-one xs-none">
                <img src="../../assets/images/breadcrumb/br-shape-2.png" alt="Image" class="br-shape-two xs-none">
                <img src="../../assets/images/breadcrumb/br-shape-3.png" alt="Image" class="br-shape-three moveHorizontal sm-none">
                <img src="../../assets/images/breadcrumb/br-shape-4.png" alt="Image" class="br-shape-four moveVertical sm-none">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-lg-7 col-md-8 col-sm-8">
                            <div class="breadcrumb-title">
                                <h2 class="header-blue-tf-color">Campaigns</h2>
                                <ul class="breadcrumb-menu list-style">
                                    <li><router-link to="/">Campaigns </router-link></li>
                                    <li>{{ this.title }}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-5 col-md-4 col-sm-4 xs-none">
                            <div class="breadcrumb-img">
                                <img src="../../assets/images/breadcrumb/br-shape-5.png" alt="Image" class="br-shape-five animationFramesTwo">
                                <img src="../../assets/images/breadcrumb/br-shape-6.png" alt="Image" class="br-shape-six bounce">
                                <img v-if="$route.params.slug == 'autonights'" src="../../assets/images/breadcrumb/breadcrumb-car.png" alt="breadcrumb" />
                                <img v-else src="../../assets/images/breadcrumb/breadcrumb-terms.png" alt="breadcrumb" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <AutoNights v-if="$route.params.slug == 'autonights'" :title="data.title" :image="data.image"></AutoNights>
            <PayLater v-if="$route.params.slug == 'refinance-now-pay-later'" :title="data.title" :image="data.image"></PayLater>

        </div>
        
        <footer class="footer-wrap mt-20 bg-rock">
            
            <div class="copyright-text">
                <p>
                    <i class="ri-copyright-line"></i>{{ currentYear }} Total. All Rights
                    Reserved By
                    <a href="javascript:void(0)">Total</a>
                </p>
                <p>
                    Handcrafted By
                    <a href="https://qwihi.com" target="_blank">Qwihi</a>
                </p>
            </div>
        </footer>
    </div>
</template>

<script>
    import Navbar from "../Layouts/Navbar";
    import PageTitle from "../Common/PageTitle";
    import AutoNights from '../Campaigns/Autonights';
    import PayLater from '../Campaigns/PayLater';
    import Footer from "../Layouts/Footer";

    export default {
        name: "CampaignPage",
        components: {
            Navbar,
            PageTitle,
            AutoNights,
            PayLater,
            Footer,
        },
        data() {
            return {
                isSticky: false,
                active: false,
                button_active_state: false,
                search: false,
                button_search_state: false,
                open: false,
                button_open_state: false,
                title: " ",
            };
        },
        computed: {
            data() {
                switch (this.$route.params.slug) {
                    case "autonights":
                        return {
                            title: "Auto Nights"
                        };
                    case "refinance-now-pay-later":
                        return {
                            title: "Refinance Now, Pay Later."
                        };
                    default:
                        return {
                            title: ""
                        };
                }
            },
        },

        mounted() {
            const slug = this.$route.params.slug;
            if (slug) {
                switch (slug) {
                    case "autonights":
                        this.title = 'Auto Nights';
                        break;
                    case "refinance-now-pay-later":
                        this.title = 'Refinance Now, Pay Later.';
                        break;
                    default:    
                        this.title = "";
                        break;
                }
            }

            const that = this;
            window.addEventListener("scroll", () => {
                let scrollPos = window.scrollY;
                if (scrollPos >= 100) {
                    that.isSticky = true;
                } else {
                    that.isSticky = false;
                }
            });
        },
    };
</script>
